import React, { useEffect } from 'react'
import {
  MediaPlayer,
  MediaProvider,
  PlayButton,
  useMediaRemote,
  useMediaState,
} from '@vidstack/react'
import { PlayIcon, PauseIcon } from '@vidstack/react/icons'

import './OralExam.scss'

const DEFAULT_AUDIO_TYPE = 'audio/wav'

export const deriveMimeTypeFromUrl = (url, defaultType = 'audio/mpeg') => {
  if (!url) return defaultType
  if (url.startsWith('blob:') || url.startsWith('data:')) return defaultType

  const cleaned = url.split('?')[0]?.toLowerCase() ?? ''
  if (cleaned.endsWith('.mp3')) return 'audio/mpeg'
  if (cleaned.endsWith('.wav')) return 'audio/wav'
  if (cleaned.endsWith('.ogg') || cleaned.endsWith('.oga')) return 'audio/ogg'
  if (cleaned.endsWith('.webm')) return 'audio/webm'
  if (cleaned.endsWith('.m4a') || cleaned.endsWith('.mp4')) return 'audio/mp4'
  return defaultType
}

const AudioPauseController = ({ isRecording }) => {
  const remote = useMediaRemote()

  useEffect(() => {
    if (isRecording) {
      remote.pause()
    }
  }, [isRecording, remote])

  return null
}

const AudioPlayerControls = ({ onPlay, onPause }) => {
  const $paused = useMediaState('paused')

  return (
    <PlayButton
      className="oral-exam__play-button"
      onClick={() => {
        if ($paused) {
          onPlay()
        } else {
          onPause()
        }
      }}
    >
      {$paused ? (
        <PlayIcon className="vds-icon" />
      ) : (
        <PauseIcon className="vds-icon" />
      )}
      <span className="oral-exam__audio-player-button-text">
        {$paused ? 'Play' : 'Pause'}
      </span>
    </PlayButton>
  )
}

const OralExamAudioPlayButton = ({
  audioType,
  audioUrl,
  isRecording,
  onPause,
  onEnded,
  onPlay = () => {},
  questionId,
  autoplay = false,
}) => {
  const resolvedAudioType = audioType ?? DEFAULT_AUDIO_TYPE

  return (
    <MediaPlayer
      autoplay={autoplay}
      className="audio-player"
      crossOrigin="anonymous"
      key={questionId || audioUrl}
      onEnded={onEnded}
      onPause={onPause}
      onPlay={onPlay}
      preload="auto"
    >
      <MediaProvider>
        <AudioPauseController isRecording={isRecording} />
        <source src={audioUrl} type={resolvedAudioType} />
      </MediaProvider>
      <div className="oral-exam__audio-player-controls">
        <AudioPlayerControls onPause={onPause} onPlay={onPlay} />
      </div>
    </MediaPlayer>
  )
}

export default OralExamAudioPlayButton
